import { tailwindConfig as config } from '@/style/config';
const { screens } = config.theme;
/**
 * 現状の画面幅に一致する breakpoint 取得
 */
export const getMatchScreenKey = () => {
    if (window.matchMedia(`(min-width: ${screens.xl})`).matches) {
        return 'xl';
    }
    if (window.matchMedia(`(min-width: ${screens.lg})`).matches) {
        return 'lg';
    }
    if (window.matchMedia(`(min-width: ${screens.md})`).matches) {
        return 'md';
    }
    if (window.matchMedia(`(min-width: ${screens.sm})`).matches) {
        return 'sm';
    }
    if (window.matchMedia(`(min-width: ${screens.xs})`).matches) {
        return 'xs';
    }
    return 'xxs';
};
